import { pick } from 'ramda'

export const makeFacilityInfo = pick([
  'name',
  'address1',
  'address2',
  'address3',
  'address4',
  'phone',
  'zip',
  'phoneNumber'
])

export const parseWebsite = url => !(url.startsWith('http://') || url.startsWith('https://')) ? `https://${url}` : url
